import {FC, useEffect, useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {isNotEmpty, toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import {initialUser, Trigger} from '../core/_models'
import clsx from 'clsx'
import {useListView} from '../core/ListViewProvider'
import {UsersListLoading} from '../components/loading/UsersListLoading'
import {createTriggers, updateTrigger, updateUserDetail, } from '../core/_requests'
import {useQueryResponse} from '../core/QueryResponseProvider'
import { PasswordMeterComponent } from '../../../../../../_metronic/assets/ts/components'
import { useCompanies } from '../../../../auth/core/Companies'

type Props = {
  isUserLoading: boolean
  trigger: Trigger
}



const UserEditModalForm: FC<Props> = ({trigger, isUserLoading}) => {
  const {setItemIdForUpdate,} = useListView()
  const {refetch} = useQueryResponse()
  const {defaultCompany,companies,updateDefaultCompany} = useCompanies()

  let triggerSchema = Yup.object().shape({
        keyword: Yup.string()
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Keyword is required'),
        description: Yup.string()
        .min(3, 'Minimum 3 symbols')
        .max(500, 'Maximum 500 symbols')
        .required('Description is required'),
    
    })
 

  const [userForEdit] = useState<Trigger>({
    ...trigger,
    keyword: trigger.keyword || initialUser.keyword,
    description: trigger.description || initialUser.description,
   })

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
  }

  useEffect(() => {
    PasswordMeterComponent.bootstrap()
  }, [])



  const formik = useFormik({
    initialValues: userForEdit,
    validationSchema: triggerSchema,
    onSubmit: async (values, {setSubmitting}) => {
      setSubmitting(true)
      try {
        if(isNotEmpty(trigger._id)){
          await updateTrigger(values,trigger._id,defaultCompany?.company_id ?? '')
        }
        else{
          await createTriggers(values,defaultCompany?.company_id ?? '');
        }
          setSubmitting(true)
          cancel(true)
      } catch (ex) {
        console.error(ex)
      } finally {
        setSubmitting(true)
        cancel(true)
      }
    },
  })

  return (
    <>
      <form id='kt_modal_add_user_form' className='form' onSubmit={formik.handleSubmit} noValidate>
        {/* begin::Scroll */}
        <div
          className='d-flex flex-column scroll-y me-n7 pe-7'
          id='kt_modal_add_user_scroll'
          data-kt-scroll='true'
          data-kt-scroll-activate='{default: false, lg: true}'
          data-kt-scroll-max-height='auto'
          data-kt-scroll-dependencies='#kt_modal_add_user_header'
          data-kt-scroll-wrappers='#kt_modal_add_user_scroll'
          data-kt-scroll-offset='300px'
        >
          {/* begin::Input group */}
         
         <div>
          <div className='fv-row mb-5 mt-5'>
          <label className='required fw-bold fs-6 mb-2'>Keyword</label>
            {/* end::Label */}

            {/* begin::Input */}
            <input
              placeholder='Keyword'
              {...formik.getFieldProps('keyword')}
              className={clsx(
                'form-control form-control-solid mb-3 mb-lg-0',
                {'is-invalid': formik.touched.keyword && formik.errors.keyword},
                {
                  'is-valid': formik.touched.keyword && !formik.errors.keyword,
                }
              )}
              type='text'
              name='keyword'
              autoComplete='off'
              disabled={formik.isSubmitting || isUserLoading}
            />
            {/* end::Input */}
            {formik.touched.keyword && formik.errors.keyword && (
              <div className='fv-plugins-message-container'>
                <span role='alert'>{formik.errors.keyword}</span>
              </div>
            )}
           
          </div>

          <div className='fv-row mb-5 mt-5'>
          <label className='required fw-bold fs-6 mb-2'>Description</label>

            <textarea
              placeholder='Description'
              {...formik.getFieldProps('description')}
              className={clsx(
                'form-control form-control-solid mb-3 mb-lg-0',
                {'is-invalid': formik.touched.description && formik.errors.description},
                {
                  'is-valid': formik.touched.description && !formik.errors.description,
                }
              )}
              name='description'
              autoComplete='off'
              disabled={formik.isSubmitting || isUserLoading}
            />
            {/* end::Input */}
            {formik.touched.description && formik.errors.description && (
              <div className='fv-plugins-message-container'>
                <span role='alert'>{formik.errors.description}</span>
              </div>
            )}
           
          </div>
          </div>
         
    
        </div>
        
        <div className='text-center pt-15'>
          <button
            type='reset'
            onClick={() => cancel()}
            className='btn btn-light me-3'
            data-kt-users-modal-action='cancel'
            disabled={formik.isSubmitting || isUserLoading}
          >
            Discard
          </button>

          <button
            type='submit'
            className='btn btn-primary'
            data-kt-users-modal-action='submit'
            disabled={isUserLoading || formik.isSubmitting || !formik.isValid || !formik.touched}
          >
            <span className='indicator-label'>Submit</span>
            {(formik.isSubmitting || isUserLoading) && (
              <span className='indicator-progress'>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
        {/* end::Actions */}
      </form>
      {(formik.isSubmitting || isUserLoading) && <UsersListLoading />}
    </>
  )
}

export {UserEditModalForm}
